/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type TradingOrderListOrdersStatus = (typeof TradingOrderListOrdersStatus)[keyof typeof TradingOrderListOrdersStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TradingOrderListOrdersStatus = {
  open: 'open',
  filled: 'filled',
  cancelled: 'cancelled',
} as const;
